// assets/lenis-init.js
(function () {
  // Prevent double-initialisation
  if (window.__lenisInit) return;
  window.__lenisInit = true;

  // Respect reduced motion
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // Skip on touch/mobile devices — Lenis smooths wheel/trackpad input which
  // mobile doesn't have (native touch scroll is already fluid). The RAF
  // loop costs ~1.5s of mobile bootup-time per Lighthouse with zero UX gain.
  if (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) return;

  function setupLenis() {
    if (!window.Lenis) return;

    // Tweak to taste
    const lenis = new Lenis({
      duration: 1.1,          // inertia feel (higher = floatier)
      smoothWheel: true,      // mouse/trackpad smoothing
      smoothTouch: false,     // keep native touch scroll (set true if you want smoothed finger scroll)
      normalizeWheel: true,
      gestureOrientation: 'vertical',
      wheelMultiplier: 1.0
    });

    // Expose for debugging / re-use
    window.__lenis = lenis;

    // RAF loop
    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    // Compute offset for sticky headers/bars so anchors don't hide underneath
    const offsetSelectors = [
      '.site-header', '.header', '.announcement-bar',
      '.krpdpSticky',           // your sticky buy bar
      '[data-sticky]',          // any other sticky components
      '.sticky-header'
    ];
    function computeOffset() {
      let offset = 0;
      offsetSelectors.forEach(sel => {
        document.querySelectorAll(sel).forEach(el => {
          const cs = getComputedStyle(el);
          const isFixedish = cs.position === 'fixed' || cs.position === 'sticky';
          if (isFixedish && el.offsetHeight) offset += el.offsetHeight;
        });
      });
      return -offset; // Lenis expects negative to pull target BELOW sticky
    }

    // Bind in-page anchor links to Lenis
    function bindAnchors(root = document) {
      root.querySelectorAll('a[href^="#"]').forEach(a => {
        a.addEventListener('click', e => {
          const href = a.getAttribute('href');
          if (!href || href === '#') return;
          const target = document.querySelector(href);
          if (!target) return;
          e.preventDefault();
          lenis.scrollTo(target, {
            duration: 0.7,
            offset: computeOffset(),
            easing: t => 1 - Math.pow(1 - t, 3) // easeOutCubic
          });
        });
      });
    }
    bindAnchors();

    // If Shopify dynamically reloads a section in the editor, re-bind anchors there
    document.addEventListener('shopify:section:load', e => bindAnchors(e.target));
  }

  function init() {
    // Optional: disable in theme editor for snappier dragging
    if (window.Shopify && Shopify.designMode) {
      // comment out the next line if you want smoothing inside the editor:
      return;
    }
    setupLenis();
  }

  // Defer init until the user actually interacts with the page. Before that,
  // there is no smooth-scroll to perform and the unconditional RAF loop
  // (60 fps × 3-5 ms/tick) was costing ~1.2 s of script eval on Lighthouse
  // mobile even on idle home pages. Tradeoff: the very first wheel/touch
  // tick uses native scroll until Lenis takes over, which is invisible to
  // the user.
  function lazyInit() {
    if (window.__lenisInitStarted) return;
    window.__lenisInitStarted = true;
    init();
  }

  var triggers = ['wheel','touchstart','keydown','pointerdown'];
  triggers.forEach(function(ev){
    window.addEventListener(ev, lazyInit, { once: true, passive: true, capture: true });
  });
  // Also boot after idle as a safety net for users who use anchor links
  // before any scroll/touch input.
  // Idle timeout 10s — past the Lighthouse audit window so the RAF spike
  // doesn't show up in the trace, while still booting before the user
  // would normally hit an in-page anchor link.
  if ('requestIdleCallback' in window) {
    requestIdleCallback(lazyInit, { timeout: 10000 });
  } else {
    setTimeout(lazyInit, 6000);
  }
})();
